core-toggle {
  display: flex;
}

.core-toggle {
  display: flex;
  align-items: flex-start;
  gap: var(--number-spacing-2xsmall);
}

.core-toggle .toggle-wrapper {
  display: flex;
  padding: var(--number-spacing-5xsmall);
  justify-content: center;
  align-items: center;
}

.core-toggle .infos-box {
  display: flex;
  flex-direction: column;
}

.core-toggle .toggle-label, .toggle-description {
  color: var(--color-neutral-content-medium);
}

.core-toggle .toggle--disabled .toggle-box {
  cursor: not-allowed;
}

.core-toggle .toggle-box {
  display: inline-block;
  position: relative;
  width: 36px;
  height: 1.25rem;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  overflow: hidden;
  border-radius: var(--number-radius-round);
  cursor: pointer;
}

.core-toggle .toggle-box:focus-visible {
  outline: 2px solid var(--color-global-border-focus);
  outline-offset: 2px;
}

.core-toggle .toggle-background {
  display: flex;
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  width: 100%;
  border: 1px solid var(--color-selection-primary-border-default);
  border-radius: var(--number-radius-round);
  box-sizing: border-box;
  transition: background-color var(--motion-duration-fast) var(--motion-easing-move),
    border var(--motion-duration-fast) var(--motion-easing-move);
}

.core-toggle .toggle-box span {
  pointer-events: none;
}

.core-toggle .toggle-inner {
  display: flex;
  align-items: center;
  width: 200%;
  margin-left: 0;
  transition: margin var(--motion-duration-medium) var(--motion-easing-move);
}

.core-toggle .option {
  display: flex;
  width: 50%;
  height: 1.25rem;
  padding: 0;
}

.core-toggle:not(.toggle--disabled) .option--true {
  background-color: var(--color-selection-primary-background-selected);
}

.core-toggle:not(.toggle--disabled) .option--false {
  background-color: var(--color-selection-primary-background-default);
}

.core-toggle .toggle-handle {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0;
  bottom: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin: 0;
  border: 1px solid var(--color-selection-primary-border-default);
  border-radius: var(--number-radius-round);
  box-sizing: border-box;
  background-color: var(--color-selection-primary-background-default);
  transition: all var(--motion-duration-medium) var(--motion-easing-move);
}

.core-toggle .toggle-inner:not(.toggle--selected .toggle-inner) {
  margin-left: -100%;
}

.core-toggle .toggle-handle:not(.toggle--selected .toggle-handle) {
  right: 1rem;
}

.core-toggle:not(.toggle--disabled) .toggle-box:hover .toggle-background,
.core-toggle:not(.toggle--disabled) .toggle-box:focus-visible .toggle-background {
  border: 1px solid var(--color-selection-primary-border-interacting);
  background-color: var(--color-selection-primary-background-interacting);
}

.core-toggle.toggle--selected:not(.toggle--disabled) .toggle-handle,
.core-toggle.toggle--selected:not(.toggle--disabled) .toggle-background {
  border: 1px solid var(--color-selection-primary-background-selected);
}

.core-toggle:not(.toggle--disabled) .toggle-box:hover .toggle-handle,
.core-toggle:not(.toggle--disabled) .toggle-box:focus-visible .toggle-handle {
  border: 1px solid var(--color-selection-primary-border-interacting);
  background-color: var(--color-selection-primary-content-selected);
}

.core-toggle.toggle--disabled .toggle-box {
  cursor: not-allowed;
}

.core-toggle.toggle--disabled .toggle-box, .core-toggle.toggle--disabled .toggle-background {
  border-color: transparent;
  background-color: var(--color-global-all-disabled-soft);
}

.core-toggle.toggle--disabled .toggle-handle {
  border-color: var(--color-global-all-disabled-soft);
}

.core-toggle .toggle-handle svg {
  animation: appear var(--motion-duration-medium) var(--motion-easing-enter);
}

.core-toggle.toggle--disabled .toggle-handle svg {
  fill: var(--color-global-all-disabled-strong);
}

@keyframes appear {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
